// Helpers to encourage fullscreen + landscape on mobile.
// Both APIs are best-effort:
//   - requestFullscreen: not supported on iOS Safari < 17, sometimes throws on phones.
//   - screen.orientation.lock: only works while in fullscreen, not supported on iOS.

interface VendorFullscreen extends Element {
  webkitRequestFullscreen?: () => Promise<void> | void;
  msRequestFullscreen?: () => Promise<void> | void;
}

export async function tryRequestFullscreen(el: HTMLElement = document.documentElement): Promise<boolean> {
  const v = el as VendorFullscreen;
  const fn =
    el.requestFullscreen?.bind(el) ??
    v.webkitRequestFullscreen?.bind(el) ??
    v.msRequestFullscreen?.bind(el);
  if (!fn) return false;
  try {
    await fn();
    return true;
  } catch {
    return false;
  }
}

interface LockableOrientation extends ScreenOrientation {
  lock?: (orientation: 'landscape' | 'landscape-primary' | 'portrait' | 'any') => Promise<void>;
}

export async function tryLockLandscape(): Promise<boolean> {
  const o = (screen as Screen & { orientation?: LockableOrientation }).orientation;
  if (!o || typeof o.lock !== 'function') return false;
  try {
    await o.lock('landscape');
    return true;
  } catch {
    return false;
  }
}

export function isPortrait(): boolean {
  return window.innerHeight > window.innerWidth;
}
